import { DEFAULT_PALETTE } from '../../core/palette';
import { POINT_DISTRIBUTION_OPTIONS } from '../../core/pointSources';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const DELAUNAY_PARAMS = [
  {
    kind: 'int',
    key: 'points',
    label: 'Punkte',
    min: 8,
    max: 12000,
    step: 1,
    scale: 'log',
    default: 340,
    bulkRange: [50, 2000],
    group: 'Netz',
  },
  {
    kind: 'enum',
    key: 'distribution',
    label: 'Verteilung',
    default: 'outline',
    group: 'Netz',
    options: POINT_DISTRIBUTION_OPTIONS,
  },
  {
    kind: 'float',
    key: 'distributionDistance',
    label: 'Reichweite',
    min: 5,
    max: 600,
    step: 1,
    default: 100,
    unit: 'px',
    group: 'Netz',
    showIf: (v) => v.distribution === 'ring' || v.distribution === 'nearText',
  },
  {
    kind: 'range',
    key: 'edgeLength',
    label: 'Kantenlänge',
    min: 0,
    max: 900,
    step: 1,
    default: [0, 260],
    unit: 'px',
    precision: 0,
    group: 'Netz',
    tooltip: 'Nur Kanten in diesem Längenbereich werden gezeichnet — filtert lange Ausreisser weg.',
  },

  {
    kind: 'enum',
    key: 'style',
    label: 'Darstellung',
    default: 'wireframe',
    segmented: true,
    group: 'Darstellung',
    options: [
      { value: 'wireframe', label: 'Gitter' },
      { value: 'filled', label: 'Flächen' },
      { value: 'both', label: 'Beides' },
    ],
  },
  {
    kind: 'float',
    key: 'lineWidth',
    label: 'Kantenstärke',
    min: 0.2,
    max: 10,
    step: 0.1,
    default: 0.8,
    unit: 'px',
    group: 'Darstellung',
    showIf: (v) => v.style !== 'filled',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 0.75,
    group: 'Darstellung',
  },
  {
    kind: 'enum',
    key: 'clip',
    label: 'Textbezug',
    default: 'all',
    segmented: true,
    group: 'Darstellung',
    options: [
      { value: 'all', label: 'Überall' },
      { value: 'outside', label: 'Aussen' },
      { value: 'inside', label: 'Innen' },
    ],
  },

  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Farbmodus',
    default: 'distance',
    group: 'Farbe',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'distance', label: 'Nach Textdistanz' },
      { value: 'size', label: 'Nach Dreiecksgrösse' },
      { value: 'random', label: 'Zufällig' },
    ],
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'blueprint' },
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type DelaunayValues = SchemaValues<typeof DELAUNAY_PARAMS>;
